import script from "./PermanentCandidates.card.vue?vue&type=script&setup=true&lang=js"
export * from "./PermanentCandidates.card.vue?vue&type=script&setup=true&lang=js"

import "./PermanentCandidates.card.vue?vue&type=style&index=0&id=9ff72264&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ff72264"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';import TouchPan from 'quasar/src/directives/touch-pan/TouchPan.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QChip});qInstall(script, 'directives', {TouchPan});
